module.exports = __webpack_public_path__ + "static/media/memberListActive.21e0df57.svg";